/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AmendmentForm_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EditAmendmentBody_amendment$ref: FragmentReference;
declare export opaque type EditAmendmentBody_amendment$fragmentType: EditAmendmentBody_amendment$ref;
export type EditAmendmentBody_amendment = {|
  +id: string,
  +title: string,
  +body: string,
  +organization: {|
    +$fragmentRefs: AmendmentForm_organization$ref
  |},
  +$refType: EditAmendmentBody_amendment$ref,
|};
export type EditAmendmentBody_amendment$data = EditAmendmentBody_amendment;
export type EditAmendmentBody_amendment$key = {
  +$data?: EditAmendmentBody_amendment$data,
  +$fragmentRefs: EditAmendmentBody_amendment$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditAmendmentBody_amendment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AmendmentForm_organization"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Amendment",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'dd1ab4e702027f1a622e48da41d0d5a5';

module.exports = node;
